import { call, put, takeLatest } from "redux-saga/effects";
import {
  addPropertyDamage,
  getPropertyDamage,
  updatePropertyDamage,
} from "../../services/incidentService";
import { apiError } from "../../utils/helper";
import * as propertyDamageAction from "../actions/propertyDamageAction";
import { propertyDamageType } from "../constants/propertyDamageType";

export function* propertyDamageSaga(params) {
  console.debug("propertyDamageSaga");
  try {
    const { data, status, error } = yield call(addPropertyDamage, params);
    if (!data && status !== 200) throw apiError(error);
    yield put(
      propertyDamageAction.propertyDamageSuccess({
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Property Damage Failed" };
    yield put(propertyDamageAction.propertyDamageFailure(data));
  }
}

export function* getPropertyDamageSaga({ caseid, incidentid }) {
  console.debug("getPropertyDamageSaga");
  try {
    const { data, status, error } = yield call(
      getPropertyDamage,
      caseid,
      incidentid
    );
    if (!data && status !== 200) throw apiError(error);
    yield put(
      propertyDamageAction.getPropertyDamageSuccess({
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Get Property Damage Failed" };
    yield put(propertyDamageAction.getPropertyDamageFailure(data));
  }
}

export function* updatePropertyDamageSaga(params) {
  console.debug("updatePropertyDamageSaga");
  try {
    const { data, status, error } = yield call(updatePropertyDamage, params);
    if (!data && status !== 200) throw apiError(error);
    const propertyDamagePage = propertyDamageType.PROPERTY_DAMAGE_PAGE;
    yield put(
      propertyDamageAction.updatePropertyDamageSuccess({
        propertyDamagePage,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Property Damage updation Failed" };
    yield put(propertyDamageAction.updatePropertyDamageFailure(data));
  }
}

const myPropertyDamageSaga = [
  takeLatest(
    propertyDamageType.POST_PROPERTY_DAMAGE_PENDING,
    propertyDamageSaga
  ),
  takeLatest(
    propertyDamageType.GET_PROPERTY_DAMAGE_PENDING,
    getPropertyDamageSaga
  ),
  takeLatest(
    propertyDamageType.PUT_PROPERTY_DAMAGE_PENDING,
    updatePropertyDamageSaga
  ),
];

export default myPropertyDamageSaga;
